var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetAsDefaultEntityTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.00087C13.5 11.0384 11.0366 13.5 7.99913 13.5C4.96165 13.5 2.5 11.0384 2.5 8.00087C2.5 4.96165 4.96165 2.5 7.99913 2.5C11.0366 2.5 13.5 4.96165 13.5 8.00087Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54138 7.28125H8.4579V10.9478H7.54138V7.28125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.251429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54163 5.56568C7.54163 5.31259 7.7468 5.10742 7.99989 5.10742C8.25298 5.10742 8.45815 5.31259 8.45815 5.56568C8.45815 5.81877 8.25298 6.02394 7.99989 6.02394C7.7468 6.02394 7.54163 5.81877 7.54163 5.56568Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.628571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetAsDefaultEntityTooltipIcon);
export default __webpack_public_path__ + "static/media/set-as-default-entity-tooltip-icon.2935c9efc86f65737debda22f58cd85b.svg";
export { ForwardRef as ReactComponent };